var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 20.5,
    height: 20.5,
    rx: 6.25,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4187 12.4091H12.9156C12.7642 12.1778 12.5668 11.9804 12.3355 11.829V6.67275C12.3355 6.38387 12.2208 6.10681 12.0165 5.90253C11.8122 5.69826 11.5351 5.5835 11.2463 5.5835C10.9574 5.5835 10.6803 5.69826 10.476 5.90253C10.2718 6.10681 10.157 6.38387 10.157 6.67275V11.829C9.79565 12.0639 9.52016 12.4096 9.37182 12.8143C9.22347 13.219 9.21025 13.6608 9.33415 14.0736C9.45804 14.4865 9.71237 14.848 10.059 15.1041C10.4057 15.3602 10.826 15.4971 11.257 15.4942C11.5883 15.4932 11.9141 15.4097 12.2051 15.2515C12.4961 15.0932 12.7432 14.8651 12.9242 14.5876H17.4187C17.7076 14.5876 17.9847 14.4728 18.1889 14.2686C18.3932 14.0643 18.508 13.7872 18.508 13.4983C18.508 13.2095 18.3932 12.9324 18.1889 12.7281C17.9847 12.5238 17.7076 12.4091 17.4187 12.4091Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.b4cc391b60bd9636de93ec888e31cf8f.svg";
export { ForwardRef as ReactComponent };